import React from 'react';
import {
  UserSettingsTab,
} from '@backstage/plugin-user-settings';
import { NotificationSettings } from '../notifications/NotificationSettings';

export const settingsPage = (
  <UserSettingsTab path="/notifications" title="Notifications">
    <NotificationSettings />
  </UserSettingsTab>
);

